import React, { useState, useEffect } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate } from "react-router-dom";
import { Menu, Row, Col, Avatar } from 'antd';

const Manage = () => {
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const navigate = useNavigate();
    const titles = {
        '/cramSchool/admin/AdminNews': '最新消息公告',
        '/cramSchool/admin/Maintain': '形象介紹、聯絡資訊維護',
        '/cramSchool/admin/AdminEnviorment': '環境介紹內容管理',
        // '/cramSchool/admin/AdminTeacher': '師資介紹內容管理',
        '/cramSchool/admin/AdminClass': '課程介紹內容管理',
        '/cramSchool/admin/AdminTidbits': '上課花絮內容管理',
        '/cramSchool/admin/AdminShareLearning': '學習見證內容管理',

    }
    const item = [
        {
            key: "/cramSchool/admin/AdminNews",
            label: `最新消息公告`,
        },
        {
            key: "/cramSchool/admin/Maintain",
            label: `形象介紹、聯絡資訊維護`,
        },
        // {
        //     key: "/cramSchool/admin/AdminEnviorment",
        //     label: `環境介紹內容管理`,
        // },
        // {
        //     key: "/cramSchool/admin/AdminTeacher",
        //     label: `師資介紹內容管理`,
        // },
        {
            key: "/cramSchool/admin/AdminClass",
            label: `課程介紹內容管理`,
        },
        {
            key: "/cramSchool/admin/AdminTidbits",
            label: `上課花絮內容管理`,
        },
        {
            key: "/cramSchool/admin/AdminShareLearning",
            label: `學習見證內容管理`,
        },]
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
    }
    return (
        <>
            <Menu
                onClick={onSelect}
                selectedKeys={selecte_keys}
                mode="horizontal"
                items={item}
                style={{ position: 'relative', display: 'flex', justifyContent: 'center' }} />
            {/* <div style={{ minHeight: '60vh' }}>
                <Outlet />
            </div> */}
        </>
    )

};
export default Manage;